import React, { useState, useEffect } from "react";
import dashboardclasses from "../dashboard.module.css";
import { IoClose } from "react-icons/io5";
import { useForm } from "react-hook-form";
import { Services } from "../../Services";
import { toast } from "react-toastify";

import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { validateEmptySpaces } from "../../Components/utils/validations";
function AddCategory(props) {
    const Navigate = useNavigate();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const [productError, setproductError] = useState(false);
    const [serviceLoad, setserviceLoad] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [serviceSearch, setserviceSearch] = useState([]);
    const [selectedService, setSelectedSerive] = useState({
        label: "",
        value: "",
    });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        console.log(props.editable);
        if (props.editable) {
            reset({
                discount_servicecost: Number(
                    props.editable.discount_servicecost
                ),
                status: props.editable.status,
                servicecost: Number(props.editable.servicecost),
                vendorcharges: Number(props.editable.vendorcharges),
            });
        }

        const close = (e) => {
            if (e.key == "Escape") {
                console.log("close");
                props.setmodal(false);
                props.setEditable(false);
            }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
    }, []);

    const CancelHandler = (e) => {
        e.stopPropagation();
        props.setmodal(false);
        props.setEditable(false);
    };
    useEffect(() => {
        let searchApi;
        if (searchTerm.length > 0) {
            searchApi = setTimeout(() => {
                setserviceLoad(true);
                Services.SearchServices(
                    "POST",
                    JSON.stringify({ servicename: searchTerm }),
                    token
                )
                    .then((res) => {
                        setserviceLoad(false);
                        let searchproducts = res?.Services?.map((item) => {
                            return {
                                label: item.servicename,
                                value: item._id,
                            };
                        });
                        if (res.Services.length > 0) {
                            setShowSearch(true);
                        }
                        setserviceSearch(searchproducts);
                    })
                    .catch((err) => {
                        setserviceLoad(false);
                        console.log(err);
                    });
            }, 300);
        }
        return () => {
            clearTimeout(searchApi);
        };
    }, [searchTerm]);
    const searchhandler = (e) => {
        setSearchTerm(e);
    };
    const buttonHandler = (e) => {
        setproductError(false);
        let name = e.currentTarget.getAttribute("name");
        setSelectedSerive({
            name: e.currentTarget.getAttribute("name"),
            value: e.currentTarget.getAttribute("id"),
        });
        setShowSearch(false);

        setTimeout(() => {
            setSearchTerm((prev) => name);
        }, 100);
        setserviceSearch([]);
    };

    const openhandler = (e) => {
        e.stopPropagation();
        if (e.currentTarget.getAttribute("id") !== "productSearch") {
            setserviceSearch([]);
        }
    };

    const onSubmit = (data) => {
        let jsonData = {
            ...data,
            discount_servicecost: Number(data.discount_servicecost),
            servicecost: Number(data.servicecost),
            vendorcharges: Number(data.vendorcharges),
            servicename: selectedService.label,
            serviceid: selectedService.value,
        };

        if (!props.editable) {
            const token = {
                Authorization: `token ${sessionStorage.getItem("token")}`,
            };

            if (selectedService.label.length == 0) {
                alert("Please Search for a service");
                return;
            }
            Services.Add_Services_city(
                "POST",
                JSON.stringify({ ...jsonData }),
                token
            )
                .then((res) => {
                    console.log(res);
                    props.tableload(false);
                    if (res.Status === 1) {
                        Navigate(
                            `/Services/City?page=1&city=${props.selectedCity}`
                        );
                        props.setpageCount(1);
                        props.setmodal(false);

                        if (props?.search) {
                            props.searchAPI(0, props.selectedCity);
                        } else {
                            props.getCategories(props.selectedCity, 0);
                        }
                        props.setEditable(false);
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((error) => {
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(error);
                });
        } else if (props.editable) {
            let jsonData1 = {
                ...jsonData,

                serviceid: props.editable.serviceid,
                city: props.editable.city,
                _id: props.editable._id,
            };

            let formaata = new FormData();
            Object.keys(jsonData1).forEach((key) => {
                formaata.set(key, jsonData1[key]);
            });

            fetch(
                `${process.env.REACT_APP_BASE_URL_PYTHON}/${Services.Update_Service_City}`,
                {
                    method: "POST",
                    body: formaata,
                    Authorization: `token ${sessionStorage.getItem("token")}`,
                }
            )
                .then((response) => response.json())
                .then((res) => {
                    console.log(res);
                    props.tableload(true);
                    if (res.Status === 1) {
                        Navigate(
                            `/Services/City?page=1&city=${props.selectedCity}`
                        );
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.setEditable(false);
                        if (props?.search) {
                            props.searchAPI(0, props.selectedCity);
                        } else {
                            props.getCategories(props.selectedCity, 0);
                        }

                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((error) => {
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(error);
                });
        }
    };

    return (
        <div className={dashboardclasses.modal} onClick={CancelHandler}>
            <div
                className={dashboardclasses["modal-content"]}
                onClick={openhandler}>
                <div className={dashboardclasses["modal-content-header"]}>
                    <div>
                        <h3>
                            {props.editable ? "Update Service" : "Add Service"}
                        </h3>
                        <p>
                            {props.editable ? "Update Service" : "Add Service"}{" "}
                            and necessary information from here
                        </p>
                    </div>
                    <button
                        className={dashboardclasses["close-btn"]}
                        onClick={CancelHandler}>
                        <IoClose size={22} color={"red"} />
                    </button>
                </div>
                <form
                    className={dashboardclasses["add-items"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    {!props.editable && (
                        <div className={dashboardclasses["item-image-upload"]}>
                            <label htmlFor="servicecost"> City</label>
                            <div className={dashboardclasses["select"]}>
                                <select
                                    {...register("city", {
                                        required: "City is required",
                                    })}>
                                    {props.cities.map((item) => (
                                        <option value={item.cityname}>
                                            {item.cityname}
                                        </option>
                                    ))}
                                </select>

                                {errors?.city && (
                                    <p className={dashboardclasses["error"]}>
                                        {errors?.city?.message}
                                    </p>
                                )}
                            </div>
                        </div>
                    )}
                    {!props.editable && (
                        <div className={dashboardclasses["item-image-upload"]}>
                            <label htmlFor="productId">Service</label>
                            <div className={dashboardclasses["select"]}>
                                <Select
                                    options={serviceSearch}
                                    onInputChange={searchhandler}
                                    value={selectedService}
                                    onChange={(data) => {
                                        setSelectedSerive(data);
                                    }}
                                    placeholder="Search Service"
                                    // noOptionsMessage={() => "No Student Found"}
                                    isLoading={serviceLoad}
                                    styles={{
                                        // Set the width to 100%
                                        // indicatorSeparator: (provided) => ({
                                        //     ...provided,
                                        //     display: "none",
                                        // }),
                                        input: (provided) => ({
                                            ...provided,
                                            margin: "0rem",
                                            padding: "0rem",
                                        }),
                                        container: (provided) => ({
                                            ...provided,
                                            // marginBottom: "0.4rem",
                                            height: "3rem",
                                        }),
                                        control: (provided) => ({
                                            ...provided,
                                            width: "100%",
                                            border: "1px solid rgba(229, 231, 235, 1)",
                                            borderRadius: "10px",
                                            backgroundColor:
                                                "rgba(229, 231, 235, 0.6)",
                                        }),
                                    }}
                                />
                            </div>
                        </div>
                    )}
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="servicecost">Service Cost</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                step={1}
                                {...register("servicecost", {
                                    required: "Service Cost is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.servicecost && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.servicecost?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="discount_servicecost">
                            Discount Service Cost
                        </label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                step={1}
                                {...register("discount_servicecost", {
                                    required: "Discount is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.discount_servicecost && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.discount_servicecost?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="vendorcharges">Vendor Charges</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                step={1}
                                {...register("vendorcharges", {
                                    required: "Vendor Charges is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.vendorcharges && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.vendorcharges?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="vendorcharges"> Status</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("status", {
                                    required: "Status is required",
                                    validate: validateEmptySpaces,
                                })}>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                            {errors?.status && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.status?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["add-btn"]}>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={dashboardclasses["add-category-btn"]}>
                            {props.editable ? "update" : "Add Service"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
